export enum RolUsuario {
  ADMIN_FINANZAS = 1,
  ADMIN_RRHH = 2,
  ADMIN_PMO = 3,
  PMO = 4,
  USUARIO_SCO = 5,
  ADMIN_TI = 6,
  ADMIN_GENERAL = 7,
  ADMIN_SERVICIOS = 8,
  ADMIN_RESTRINGIDO = 9,
  NOMINA = 10,
  LISTADO_SERVICIOS = 11,
  ORDEN_COMPRA = 12
}

export const ROLES_CONFIG = {
  
  ADMIN_ACCESS: [
    RolUsuario.ADMIN_FINANZAS,
    RolUsuario.ADMIN_GENERAL,
    RolUsuario.ADMIN_PMO,
    RolUsuario.PMO,
    RolUsuario.USUARIO_SCO,
    RolUsuario.ADMIN_TI,
    RolUsuario.ADMIN_GENERAL,
    RolUsuario.ADMIN_SERVICIOS,
    RolUsuario.ADMIN_RESTRINGIDO,
    RolUsuario.NOMINA,
    RolUsuario.LISTADO_SERVICIOS,
    RolUsuario.ORDEN_COMPRA
  ],

  EMPLEADOS: [RolUsuario.ADMIN_SERVICIOS],

  CATALOGOS: [RolUsuario.ADMIN_SERVICIOS],

  LISTADO_SERVICIOS: [
    RolUsuario.ADMIN_FINANZAS,
    RolUsuario.ADMIN_GENERAL,
    RolUsuario.ADMIN_PMO,
    RolUsuario.PMO,
    RolUsuario.USUARIO_SCO,
    RolUsuario.ADMIN_TI,
    RolUsuario.ADMIN_GENERAL,
    RolUsuario.ADMIN_SERVICIOS,
    RolUsuario.ADMIN_RESTRINGIDO,
    RolUsuario.NOMINA,
    RolUsuario.LISTADO_SERVICIOS,
    RolUsuario.ORDEN_COMPRA
  ],

  CLIENTES: [RolUsuario.ADMIN_SERVICIOS, RolUsuario.ADMIN_RESTRINGIDO],

  PROVEEDORES: [RolUsuario.ADMIN_SERVICIOS, RolUsuario.ADMIN_RESTRINGIDO],

  REPORTE_PROYECTOS: [RolUsuario.ADMIN_SERVICIOS, RolUsuario.ADMIN_PMO, RolUsuario.PMO],

  SERVICIOS_PROYECTOS: [
    RolUsuario.ADMIN_FINANZAS,
    RolUsuario.ADMIN_GENERAL,
    RolUsuario.ADMIN_PMO,
    RolUsuario.PMO,
    RolUsuario.USUARIO_SCO,
    RolUsuario.ADMIN_TI,
    RolUsuario.ADMIN_GENERAL,
    RolUsuario.ADMIN_SERVICIOS,
    RolUsuario.ADMIN_RESTRINGIDO,
    RolUsuario.NOMINA,
    RolUsuario.LISTADO_SERVICIOS,
    RolUsuario.ORDEN_COMPRA
  ],

  SOLICITUDES: [RolUsuario.ADMIN_SERVICIOS, RolUsuario.PMO],
 
  ASIGNACIONES: [RolUsuario.ADMIN_SERVICIOS],
 
  REPORTES: [RolUsuario.ADMIN_SERVICIOS, RolUsuario.ADMIN_PMO, RolUsuario.PMO, RolUsuario.ADMIN_GENERAL],
 
  REPORTES_COLAB: [RolUsuario.ADMIN_SERVICIOS, RolUsuario.ADMIN_PMO, RolUsuario.PMO],
 
  ORDEN_VENTA: [RolUsuario.ADMIN_SERVICIOS, RolUsuario.ADMIN_RESTRINGIDO, RolUsuario.ADMIN_PMO, RolUsuario.NOMINA],

  REPORTES_BITACORA: [RolUsuario.ADMIN_SERVICIOS],

  CIERRE_BITACORA: [RolUsuario.ADMIN_SERVICIOS],

 
  LISTADO_SERVICIOS_EDIT: [RolUsuario.ADMIN_SERVICIOS, RolUsuario.ADMIN_PMO, RolUsuario.PMO, RolUsuario.LISTADO_SERVICIOS],
 
  SERVICIOS_PROYECTOS_EDIT: [RolUsuario.ADMIN_SERVICIOS],

  ORDEN_COMPRA_EDIT: [
    RolUsuario.ADMIN_SERVICIOS,
    RolUsuario.ADMIN_RESTRINGIDO,
    RolUsuario.NOMINA,
    RolUsuario.ORDEN_COMPRA
  ],

  NO_RESTRICTED: [
    RolUsuario.ADMIN_FINANZAS,
    RolUsuario.ADMIN_GENERAL,
    RolUsuario.ADMIN_PMO,
    RolUsuario.PMO,
    RolUsuario.USUARIO_SCO,
    RolUsuario.ADMIN_TI,
    RolUsuario.ADMIN_GENERAL,
    RolUsuario.ADMIN_SERVICIOS
  ],
  SERVICIOS_ONLY: [RolUsuario.ADMIN_SERVICIOS],
  RESTRICTED_ONLY: [RolUsuario.ADMIN_RESTRINGIDO]
};
